
import { Component, Vue } from 'vue-property-decorator';
import AppDialog from '@/modules/Popup/components/AppDialog.vue';
import {httpResource} from "@/resources/http.resource";
import moment from "moment";
import {formatDateForServer} from "@/plugins/moment";
import {IApp} from "@/interfaces/app.interface";
import {IEventsLog} from "@/shared/EventsLog/interfaces/events-log.interface";

@Component({
  components: {
    AppDialog,
  },
})
export default class EventsLogPopup extends Vue {
  $refs: any;
  currentPopup = { blockName: 'allPages', dialogName: 'eventsLog' };
  loadingTable = false;
  filterItemType = IEventsLog.FilterItemType;
  formModel = {};
  eventsLog: IEventsLog.DefaultEventData | any[] = [];
  eventProps: IEventsLog.EventProp[] = [];
  elementDateFormat = IApp.DateFormats.ElementDateFormat;
  defaultEventProps: IEventsLog.EventProp[] = [
    { prop: 'recordId', label: 'Код', },
    { prop: 'dateEvent', label: 'Дата события', },
    { prop: 'login', label: 'Пользователь', },
    { prop: 'actionName', label: 'Событие', },
    { prop: 'fieldsChanged', label: 'Детально', },
  ];
  filters: IEventsLog.FilterItems[] = [];
  defaultFilters: IEventsLog.FilterItems[] = [
    { type: IEventsLog.FilterItemType.Input, prop: 'searchString', placeholder: 'Текст', },
    { type: IEventsLog.FilterItemType.Date,  prop: 'dateBeg', placeholder: 'Период планирования', },
    { type: IEventsLog.FilterItemType.Input, prop: 'recordId', placeholder: 'Код ', },
  ];

  get payloadPopup(): IEventsLog.PopupPayload { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

  created() {
    this.eventProps = this.payloadPopup.defaultEvents ? this.defaultEventProps : this.payloadPopup.eventProps;
    this.filters = this.payloadPopup.defaultFilters ? this.defaultFilters : this.payloadPopup.filters;
    this.filters.forEach(filter => {
      Vue.set(this.formModel, filter.prop, filter.defaultValue);
    });
    this.getEvents();
  }

  async getEvents() {
    this.loadingTable = true;
    let asyncAction = async () => {
      let action = this.payloadPopup.action;
      let params: any = {
        command: IEventsLog.Command.EventsLog,
      };

      if (this.payloadPopup.requestParams) {
        this.payloadPopup.requestParams.forEach(param => params[param.name] = param.value);
      }

      this.filters.forEach(filter => {
        if (this.formModel[filter.prop]) {
          if (filter.type === this.filterItemType.Date) {
            params[filter.prop] = formatDateForServer(this.formModel[filter.prop], IApp.DATE_FORMAT_MOMENT);
          }
          else {
            params[filter.prop] = this.formModel[filter.prop];
          }
        }
      });

      let { data: { result: { eventsLog: logArray } }} = await httpResource.httpAction({ action, params });
      this.eventsLog = logArray.map(event => {
        let newEvent = { ...event };
        Object.keys(newEvent).forEach(prop => {
          if (prop.includes('date')) {
            newEvent[prop] = newEvent[prop] ? moment(newEvent[prop]).format(IApp.DateFormats.PrintedDateTime) : '-';
          }
        });
        newEvent.dateEventNumber = event.dateEvent ? +moment(event.dateEvent).format('x') : 0;
        return newEvent;
      }).sort((a, b) => a.dateEventNumber < b.dateEventNumber ? 1 : -1);
    };

    await this.$store.dispatch('defaultResourceAction', { asyncAction });
    this.loadingTable = false;
  }

  printHtml(text: string, indexRow: number) {
    let linkHTML = text;
    if (linkHTML) {
      if (text.includes('http')) {
        let urlRegex = /(http[^\s]+)/g;
        linkHTML = text.replace(urlRegex, (url) => {
          return '<a class="app-link" href="' + url + '" target="_blank">' + url + '</a>';
        });
      }

      let elem = document.querySelector(`.events-log__table-row-${indexRow} .fieldsChanged`);
      if (elem) elem.innerHTML = linkHTML;
    }
  }

  async onClose() {
    this.$refs.appDialog.onClose();
  }

  destroyed() {
    this.onClose();
  }
}
